import { LegalEntityType } from '@omnipresentgroup/types';
import type { JSONSchema7Definition } from 'json-schema';

import { LEGAL_ENTITY_TYPE_LABELS } from '../legal-entities-list/constants';

export const LEGAL_ENTITY_TYPE_OPTIONS: JSONSchema7Definition[] = Object.values(
  LegalEntityType,
)
  .map((type) => ({
    title: LEGAL_ENTITY_TYPE_LABELS.get(type as LegalEntityType) ?? '-',
    const: type,
  }))
  .sort((a, b) => a.title.localeCompare(b.title));
